import React, { useEffect, useRef } from "react";

import { insertDisplayCode } from "../../utils/displayCode";
import { FloatingFrame } from "./FloatingFrame";

// 300 px по высоте и 100% по ширине — тест по просьбе Sape.
const FLOATING_CODE_STYLE = { width: "100%", height: 300 };

export function CodeAdapter({ entry, floating = false }) {
    const container = useRef(null);
    // Скрипты кода исполняются при вставке: повторная вставка запустила бы их второй раз.
    const inserted = useRef(false);

    useEffect(() => {
        if (!entry.code || !container.current || inserted.current) {
            return;
        }

        inserted.current = true;
        insertDisplayCode(container.current, entry.code);
    }, [entry.code]);

    if (!entry.code) {
        return null;
    }

    if (!floating) {
        return <div ref={container} />;
    }

    return (
        <FloatingFrame>
            <div ref={container} style={FLOATING_CODE_STYLE} />
        </FloatingFrame>
    );
}

export default CodeAdapter;
